import {Pipe, PipeTransform} from '@angular/core';
import Order from '../../_entities/orders/order.entity';

@Pipe({
    name: 'orderTotal',
    pure: true
})
export class OrderTotalPipe implements PipeTransform {
    transform(order: Order): number {
        const items = (order?.items ?? []) as any[];
        const total = items.reduce((result, item) => result + ((item?.itemPrice ?? 0) * (item?.quantityOrdered ?? 0)), 0);
        return +parseFloat(total.toString()).toFixed(2);
    }
}
